import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function Logout() {
  const navigate = useNavigate();

  useEffect(() => {
    // Clear tokens from localStorage
    localStorage.removeItem('authToken');
    localStorage.removeItem('refreshToken');

    // Redirect to login page
    navigate('/login');
  }, [navigate]);

  // Component doesn't need to render anything
  return null;
}

export default Logout; 